import Button from "@lhd/components/Button";
import TableAppPermission from "@lhd/features/Apps/AppPermission/components/TableAppPermission";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { StylesTabPermission } from "../../styled";
import { useSelector } from "react-redux";
import { BUTTON_HEIGHT, FONT_SIZE, FONT_SIZE_VALUE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";

const TabPermissionCreate = () => {
  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const size = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];
  return (
    <StylesTabPermission text_scale={displaySize}>
      <div className="wrap-list-button">
        <Button
          label="列権限表示"
          style={{
            fontSize: size,
            width: "fit-content",
          }}
          displaySize={displaySize}
        />
        <Button
          label="行権限表示"
          style={{
            fontSize: size,
            width: "fit-content",
          }}
          displaySize={displaySize}
        />
      </div>
      <TableAppPermission />
    </StylesTabPermission>
  );
};

export default TabPermissionCreate;
